import React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import MinutesToText from 'modules/attendance/components/MinutesToText'

type Props = {
  day: string
  minutes: number
  accumulatedMinutes: number
  onClick: () => void
  open: boolean
}

const Header = ({ day, minutes, accumulatedMinutes, onClick, open }: Props) => {
  return (
    <Box onClick={() => onClick()}>
      <Box flexDirection="row" justifyContent="spaceBetween" padding="s16" alignItems="center">
        <Text size="300" weight="medium" color="grey1000">
          {day}
        </Text>

        <Box flexDirection="row" alignItems="center" gap="s8" justifyContent="flexEnd">
          <Box gap="s2" textAlign="right">
            <MinutesToText
              value={minutes}
              size="300"
              weight="medium"
              color="grey1000"
              withPlusSign
            />
            <MinutesToText value={accumulatedMinutes} size="100" />
          </Box>

          {open ? <Icon.Medium icon="chevron-up" /> : <Icon.Medium icon="chevron-down" />}
        </Box>
      </Box>
    </Box>
  )
}

export default Header
